import { yupResolver } from "@hookform/resolvers/yup"
import map from "lodash-es/map"
import trim from "lodash-es/trim"
import * as yup from "yup"
import type { ObjectSchema } from "yup"

import type { TTFunction } from "$/i18n/i18n"

import { EFreeResponsesFormField as EFormField, type TFreeResponsesQuestion as TQuestion } from "./free-responses.types"

function _getSchema(questions: TQuestion[], t: TTFunction): ObjectSchema {
    const questionMap: Record<number, TQuestion> = Object.fromEntries(
        map(questions, (q: TQuestion, idx: number): [number, TQuestion] => [idx, q])
    )

    return yup.object({
        [EFormField.QuestionList]: yup.array().of(
            yup.object({
                id: yup.string().required(),
                answer: yup
                    .string()
                    .transform((value: string): string => trim(value))
                    .test("answer-required", t("common.inputEmptyValidation"), function (value: string): boolean {
                        const { idx } = this.parent

                        const question: TQuestion = questionMap[idx]

                        if (!question) return true

                        return question.initialState.isRequired ? value.length > 0 : true
                    })
            })
        )
    })
}

function resolver(questions: TQuestion[], t: TTFunction): ReturnType<typeof yupResolver> {
    return yupResolver(_getSchema(questions, t))
}

export { resolver as getFreeResponsesFormSchemaResolver }
